// Tiny DOM helpers used by new TS views. We avoid pulling in a framework
// to keep the bundle ~15kb + supabase-js. Everything is plain DOM APIs.

export function el<K extends keyof HTMLElementTagNameMap>(
  tag: K,
  attrs?: Partial<Record<string, string | boolean | number>>,
  children?: Array<Node | string | null | undefined>,
): HTMLElementTagNameMap[K] {
  const node = document.createElement(tag);
  if (attrs) {
    for (const [k, v] of Object.entries(attrs)) {
      if (v === false || v === null || v === undefined) continue;
      if (k === 'class') node.className = String(v);
      else if (k === 'html') node.innerHTML = String(v);
      else if (k.startsWith('on') && typeof v === 'string') node.setAttribute(k, v);
      else node.setAttribute(k, String(v));
    }
  }
  if (children) {
    for (const c of children) {
      if (c === null || c === undefined) continue;
      node.appendChild(typeof c === 'string' ? document.createTextNode(c) : c);
    }
  }
  return node;
}

export function html(strings: TemplateStringsArray, ...values: unknown[]): string {
  return strings.reduce((acc, s, i) => acc + s + escape(values[i]), '');
}

function escape(v: unknown): string {
  if (v === null || v === undefined) return '';
  const s = String(v);
  return s
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}

export function clear(node: HTMLElement): void {
  while (node.firstChild) node.removeChild(node.firstChild);
}

export function debounce<T extends (...args: never[]) => void>(
  fn: T,
  ms: number,
): (...args: Parameters<T>) => void {
  let t: ReturnType<typeof setTimeout> | undefined;
  return (...args) => {
    if (t) clearTimeout(t);
    t = setTimeout(() => fn(...args), ms);
  };
}

export function toast(msg: string, level: 'info' | 'ok' | 'warn' | 'err' = 'info'): void {
  const node = el('div', { class: `ifi-toast ifi-toast--${level}` }, [msg]);
  Object.assign(node.style, {
    position: 'fixed',
    bottom: '16px',
    right: '16px',
    padding: '10px 14px',
    background:
      level === 'err'
        ? '#5a1a1a'
        : level === 'warn'
          ? '#5a3d1a'
          : level === 'ok'
            ? '#1a5a2a'
            : '#1a2a5a',
    color: '#fff',
    borderRadius: '4px',
    fontSize: '12px',
    boxShadow: '0 4px 12px rgba(0,0,0,0.3)',
    zIndex: '9999',
    maxWidth: '320px',
  } as Partial<CSSStyleDeclaration>);
  document.body.appendChild(node);
  setTimeout(() => node.remove(), 4500);
}
